module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.banner) ? _c('div', {
    staticClass: "top-banner"
  }, [_c('a', {
    attrs: {
      "href": '' + _vm.top_banner_url + '',
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.banner,
      "width": "100%",
      "height": "auto"
    }
  })])]) : _c('div', {
    staticClass: "top-banner"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/no-banner.png"),
      "width": "100%",
      "height": "auto"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "grid-container header layer1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('ul', _vm._l((_vm.menus), function(item) {
    return _c('li', {
      staticClass: "menu-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: item.title
        }
      }
    }, [_c('span', {
      class: ['main-title', item.title.toLowerCase()]
    }, [_vm._v(_vm._s(item.title) + " ")])])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "mobile-nav",
    on: {
      "click": function($event) {
        return _vm.showMobileMenu()
      }
    }
  }, [_c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Menu")]), _vm._v(" "), (!_vm.showMenu) ? _c('div', {
    staticClass: "burger"
  }, [_c('div', {
    staticClass: "burger1"
  }), _vm._v(" "), _c('div', {
    staticClass: "burger2"
  }), _vm._v(" "), _c('div', {
    staticClass: "burger3"
  })]) : _vm._e(), _vm._v(" "), (_vm.showMenu) ? _c('div', {
    staticClass: "burger-close"
  }) : _vm._e()]), _vm._v(" "), (_vm.showMenu) ? _c('div', {
    staticClass: "mobile-nav-menu"
  }, [_c('ul', _vm._l((_vm.menus), function(item) {
    return _c('li', {
      staticClass: "menu-item",
      on: {
        "click": function($event) {
          return _vm.hideMobileMenu()
        }
      }
    }, [_c('a', {
      attrs: {
        "href": '#/' + item.title.toLowerCase()
      }
    }, [_c('span', {
      class: ['main-title', item.title.toLowerCase()]
    }, [_vm._v(" " + _vm._s(item.title) + " ")])])])
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": "home"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showForm),
      expression: "showForm"
    }],
    staticClass: "overlay-grid grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "social-latest grid-100 grid-parent"
  }, [_c('NewsletterForm', {
    on: {
      "hideForm": _vm.hideForm
    }
  })], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "layer1",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "footer grid-container grid-100 mobile-grid-100"
  }, [_c('div', {
    staticClass: "footer-newsletter grid-30 mobile-grid-100"
  }, [_c('div', {
    staticClass: "footer-newsletter-img",
    on: {
      "click": function($event) {
        return _vm.showFormSection()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/newsletter.svg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Sign Up")])])]), _vm._v(" "), (_vm.socialMediaLinks) ? _c('div', {
    staticClass: "copyright grid-70 mobile-grid-100"
  }, [_c('div', {
    staticClass: "social"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.facebookLink
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/fb_white.svg")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.twitterLink
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/twitter_white.svg")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.vimeoLink
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/vimeo-white.svg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "copyright-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyright))])])]) : _vm._e()]), _vm._v(" "), _vm._m(1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('span', [_vm._v("Ross Noble")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-extra-info grid-container grid-100 mobile-grid-100"
  }, [_c('div', {
    staticClass: "cc-logo"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/creativecommons.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cc-text"
  }, [_vm._v("Images via Flickr, thanks to: @dickdotcom for 'Claw', @tambako for 'Toucan', @bertknot for 'Bushfire' &  @dirtsailor2003 for 'Hagfish'.")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.yourfavouritestory.com"
    }
  }, [_c('div', {
    staticClass: "yfs-wrapper"
  }, [_c('div', {
    staticClass: "yfs-logo"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/yfs-logo.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "yfs-text"
  }, [_vm._v("Built by Your Favourite Story")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63f5f75f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 284
// module chunks = 0